import { PRACTICE_SLUG } from "models";

import { ContextMenuItemProps } from "components";

import {
  MissingDataDrawerPracticeType,
  YIELD_PSEUDO_PRACTICE_TYPE,
} from "pages/app/historical-practice-data-table-view/components/AddEditMissingDataDrawer.tsx";

type BulkPracticeMenuEntry = {
  label: string;
  isEnabled: boolean;
};

type BulkPracticeMenuParams = {
  growingPeriod: BulkPracticeMenuEntry;
  seeding: BulkPracticeMenuEntry;
  tillage: BulkPracticeMenuEntry;
  organicFertilizer: BulkPracticeMenuEntry;
  // mineral fertilizer and yield only exist in the all-fields data table view
  mineralFertilizer?: BulkPracticeMenuEntry;
  yieldEntry?: BulkPracticeMenuEntry;
  hidePracticeButtons?: boolean;
  onSelect: (practiceType: MissingDataDrawerPracticeType) => void;
};

// The bulk drawer still needs to know which practice it is editing (PE-972 replaces it with a single drawer covering
// all practices), so the data tables offer that choice as a menu behind the bar's Add data / Edit data buttons
export const getBulkPracticeMenuItems = ({
  growingPeriod,
  seeding,
  tillage,
  organicFertilizer,
  mineralFertilizer,
  yieldEntry,
  hidePracticeButtons,
  onSelect,
}: BulkPracticeMenuParams): ContextMenuItemProps[] => {
  const toMenuItem = ({ label, isEnabled }: BulkPracticeMenuEntry, practiceType: MissingDataDrawerPracticeType): ContextMenuItemProps => ({
    label,
    state: isEnabled ? undefined : "disabled",
    dataTestId: `bulk-action-bar-practice-${practiceType.toLowerCase()}`,
    onClick: () => onSelect(practiceType),
  });

  const items: ContextMenuItemProps[] = [toMenuItem(growingPeriod, PRACTICE_SLUG.CROPS)];

  if (hidePracticeButtons) return items;

  items.push(
    toMenuItem(seeding, PRACTICE_SLUG.SEEDINGS),
    toMenuItem(tillage, PRACTICE_SLUG.TILLAGES),
    toMenuItem(organicFertilizer, PRACTICE_SLUG.ORGANIC_FERTILIZERS)
  );

  if (mineralFertilizer) items.push(toMenuItem(mineralFertilizer, PRACTICE_SLUG.MINERAL_FERTILIZERS));
  if (yieldEntry) items.push(toMenuItem(yieldEntry, YIELD_PSEUDO_PRACTICE_TYPE));

  return items;
};
